<script lang="ts" setup>
import { useRouter } from 'vue-router';

import MascotIcon from '~/assets/icons/contacts-mascot.svg';

const router = useRouter();

const toUpload = () => {
  router.push({ name: 'contactsUpload' });
};
</script>

<template>
  <div class="empty-contacts">
    <div class="empty-contacts__content">
      <MascotIcon />
      <div class="empty-contacts__text">
        <h4>Список контактов пуст</h4>
        <p>Чтобы мы поняли, кому отправить,<br>добавьте контакты.</p>
      </div>
      <PButton
        :variant="'default'"
        :size="'small'"
        :color="'primary'"
        :disabled="false"
        :loading="false"
        :nuxt="false"
        :type="'button'"
        :block="false"
        @click="toUpload"
      >
        {{ $t('crud.add') }}
      </PButton>
    </div>
  </div>
</template>

<style scoped>
.empty-contacts {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-contacts__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
  gap: 16px;
}

.empty-contacts__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.empty-contacts__content h4 {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: var(--common-black);
}

.empty-contacts__content p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: var(--common-asphalt);
}
</style>
